'use strict'
let transformer = require("@abc/transformers");
/**
 * Default value of the v2 fields and its mapping transformer 
 */
module.exports = {
	/**
	 * the list of the migrated custom fields and its asscoaited transformer
	 */
	promisedArrivalDate : transformer.getPromisedArrivalDateTransformer,

	fakeOrder:	transformer.getFakeOrderTransformer,

	artworkRequired: transformer.getArtworkRequiredTransformer,

	revisedPromisedArrivalDate: transformer.getRevisedPromisedArrivalDateTransformer,
	
	shippingAddressPerLineItem: transformer.getShippingAddressPerLineItemTransformer,

	userUploadsUrl: transformer.getUserUploadsUrlTransformer,

	userSelection: transformer.getUserSelectionTransformer,

	variableAttributes: transformer.getVariableAttributesTransformer,
	
	finalSelection: transformer.getFinalSelectionTransformer,
	
	mcpDocumentsSource: transformer.getMcpDocumentsSourceTransformer,
	
	artworkUploadURL: transformer.getArtworkRequiredTransformer,
	
	bufferArtworkServiceHours: transformer.getBufferArtworkServiceHoursTransformer,
	
	bufferProductionHours: transformer.getBufferProductionHoursTransformer,
	
	mcpProductionHours: transformer.getMcpProductionHoursTransformer


};


// WEBPACK FOOTER //
// ./src/core/customFieldV2Mapping.js